export const createSettingsConfig = () => ({
  url: `/practitioner_preference`,
});

export const getSettingsConfig = () => ({
  url: `/notification_preference`,
});

export const getV3SettingsConfig = () => ({
  url: `/v3/notification_preference`,
});

export const listSettingsPractitionersConfig = () => ({
  url: `/practitioner/is_show`,
});

export const addPractitionerSettingsConfig = () => ({
  url: `/add_practitioner`,
});

export const organizationTimeConfig = () => ({
  url: `/organization_time`,
});
